import { createContext } from 'react';

const statisticContext = createContext();

export default statisticContext;